<span>{{ formatDateTime(date) }}</span>